import ZCheckboxButton from '../checkbox/checkbox-button.vue'

ZCheckboxButton.install = function(app) {
  app.component(ZCheckboxButton.name, ZCheckboxButton)
}

export default ZCheckboxButton